export default "__VITE_ASSET__C6$ub1Tf__"